// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"443":"160e84b2","532":"d2d694d3","875":"f3764489","900":"088ecdbc"}[chunkId] + ".js";
};